<header class="header sticky top-0 z-50 flex items-center justify-between px-5">
  <button class="lg:hidden" aria-label="toggle menu" (click)="showSidebar()">
    <app-font-icon>menu</app-font-icon>
  </button>
  <div class="text-slate-900 dark:text-violet-500">
    <a [routerLink]="['/']" class="ml-2 flex items-center gap-2 lg:ml-0">
      <app-icon name="logo" width="40" height="40"></app-icon>
      <doc-project-name class="text-xl font-bold"></doc-project-name>
    </a>
  </div>

  <app-dark-mode-toggle class="mr-2 ml-auto"></app-dark-mode-toggle>
  <a href="https://github.com/ngverse/ui" target="_blank">
    <button
      appButton
      icon
      color="secondary"
      variant="outline"
      size="sm"
      variant="link"
      aria-label="Star on Github"
    >
      <app-icon width="20" height="20" name="github"></app-icon>
    </button>
  </a>
  <div id="docsearch"></div>
</header>
